module.exports = __webpack_public_path__ + "media/images/site/tradicao_e_infra-7e2899e705d03cce5a63eda224789062.jpg";